module.exports = __webpack_public_path__ + "static/media/1021031.80d8d149.png";